import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, colorVars } from '@routific/hive/v5';

const ZapierTag: React.FC = () => {
  const { t } = useTranslation('zapier');

  return (
    <Chip
      size="sm"
      style={{
        backgroundColor: colorVars.brand.zapierLogo.underscore,
        borderColor: colorVars.brand.zapierLogo.underscore,
        color: colorVars.text.onEmphasis.default,
      }}
    >
      {t('tag')}
    </Chip>
  );
};

export default ZapierTag;
